<template>
  <div class="footer">
    <!--footer-->
    <div class="page-width">
      <!-- <img class="logo" src="../assets/img/logogray.png" alt=""> -->
      <img class="logo" src="../assets/img/logo2x.png" alt="">
      <div class="clear">
        <div class="footer_left">
          <!-- <h4>{{ $t('info') }}</h4> -->
          <ul>
            <!-- <li>{{ $t('info')}}</li> -->
            <!-- <router-link to="/contact-us">{{ $t('contact') }}</router-link> -->
            <li @click="$router.push({path:'/contact-us'})">{{ $t('contact')}}</li>
            <li @click="$router.push({path:'/terms-of-service'})">{{ $t('terms')}}</li>
            <li @click="$router.push({path:'/privacy'})">{{ $t('privacyTitle')}}</li>
            <li @click="$router.push({path:'/about-us'})">{{ $t('aboutUs')}}</li>
          </ul>
        </div>
        <div class="footer_right">
          <!-- <h4>{{ $t('social') }}</h4> -->
          <ul class="social-icons">
            <li><a :href="companyFB" target="_blank" class="social-icons__link Facebook"></a></li>
            <li><a :href="companyIG" target="_blank" class="social-icons__link Instagram"></a></li>
            <li class="wechat_customer">
              <a href="javascript:;" class="social-icons__link"> </a>
              <div class="social_icon_hover">
                <div class="social_hover_inr">
                  <img src="../assets/img/Wechat_Customer_Service.png">
                </div>
              </div>
            </li>
            <li class="wechat_official">
              <a href="javascript:;"  class="social-icons__link">
                <div class="social_icon_hover">
                  <div class="social_hover_inr">
                    <img src="../assets/img/Wechat_Customer_Service.png">
                  </div>

                </div>
              </a>
            </li>
            <li class="tikTok_ic_block">
              <a href="javascript:;"  class="social-icons__link">
                <div class="social_icon_hover">
                  <div class="social_hover_inr">
                    <img src="../assets/img/TikTok.png">
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--end footer-->

    <div class="page-width">
      <img class="Pay" src="../assets/img/payment.png" alt="">
    </div>
  </div>
</template>

<script>           
import { Config } from '../../config/default';
import { mapState } from 'vuex'
export default {
  name: "munFooter",
  data() {
    return{
      companyFB: Config.COMPANY_FB,
      companyIG: Config.COMPANY_IG,
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/footer.less";
</style>




// WEBPACK FOOTER //
// src/components/munFooter.vue